import * as React from 'react'
import {Lang} from 'yougile-lang'
import {Util} from 'yougile-util'
import {UserProxy} from '../../../extensions/proxies/user-proxy'
import {UserAvatarV2} from '../../common/user-avatar-v2/user-avatar-v2'
import {TaskData} from 'yougile-model'

interface Props {
  user: UserProxy | undefined
  tasks: TaskData[]
}

export const ByUserColumnHeader = (props: Props) => {
  const {user, tasks} = props
  const bem = Util.bemFrom('by-user', 'column', 'header')

  const allUserTasks = tasks.filter(
    t =>
      (user ? t.assigned.indexOf(user.userId) > -1 : !t.assigned) &&
      t.gtdStage !== 'done'
  )
  const openTasks = allUserTasks.length

  return (
    <div className={bem()}>
      <div className={bem('who')}>
        {!!user && (
          <UserAvatarV2 {...user} className={bem('who', 'avatar')} size={24} />
        )}
        {!user && <div className={bem('who', 'empty')} />}
        <div className={bem('who', 'name')}>
          {user ? user.userName : Lang.msg.byUserNoAssignee}
        </div>
        <div className={bem('count-list')}>
          <div className={bem('count-item')}>
            <div className={bem('count-item', 'name')}>
              {Lang.msg.byUserOpenTasksCount}
            </div>
            <div className={bem('count-item', 'value')}>{openTasks}</div>
          </div>
        </div>
      </div>
      <div className={bem('count-list')} />
    </div>
  )
}
